// extracted by mini-css-extract-plugin
export default {"more":"FooterPost_more__IKSLz"};